module.exports = __webpack_public_path__ + "media/images/ibu__social__logo__youtube-2ff21ebe91e31a6ddd16309e75c9c378.svg";